import request from '@/utils/request';
import controlSchema from '@/views/shop-decoration/home-decoration/control-schema';
import { MessageBox } from 'element-ui';
import Schema from 'async-validator';
import attrRules from '@/views/shop-decoration/home-decoration/components/control-attr-area/components/rules.js';
import { Message } from 'element-ui';
import appStore from './app';

/**
 * 通用提交方法
 * type save publish
 */
const _submit = (type, state) => {
  let url = '';
  const storeName = state.workHeadList[0].attrs.titleContent;
  const remarksName = state.workHeadList[0].attrs.remarkName;
  const params = {
    ...state.shopFormData,
    // 保存则保持原状态
    status: type === 'publish' ? 1 : state.shopFormData.status,
    content: JSON.stringify({
      list: state.workControlList,
      listHead: state.workHeadList,
      listdesc: state.listdesc,
      version: state.version,
      animationFlag: state.animationFlag,
      liveFlag: state.liveFlag,
      channelTypeList: state.channelTypeList,
    }),
    channelTypeList: state.channelTypeList,
    background: state.background,
    storeName,
    remarksName,
    topicName: storeName,
  };

  const urlPrefix =
    appStore.state.sellerBookingType === 1 ? 'bookingAdmin' : 'business';
  if (state.storeType === 'main') {
    url = `/${urlPrefix}/sellerStore/save`;
  } else if (state.storeType === 'special') {
    url = `/${urlPrefix}/topic/saveOrUpdate`;
  }

  return request.post(url, params, {
    catchBusinessErr: true,
    showLoading: true,
  });
};

const initFooterNavData = (curData, storeType) => {
  const footerNav = curData.list.find(item => {
    return item.type === 'footerNav';
  });
  if (!footerNav) {
    curData.list.push({
      ...getDefaultFooterNavData(storeType),
      _frontId: utils.genId(),
    });
  }
};

const decoration = {
  namespaced: true,
  state: {
    workControlListBackup: null,
    workHeadListBackUp: null,
    workControlList: [],
    workHeadList: [],
    version: '',
    listdesc: null,
    curSelectControlId: '',
    shopFormData: null,
    isDragControl: false,
    background: '',
    animationFlag: false,
    liveFlag: false,
    channelTypeList: [],
    isPreviewState: false,
    storeType: '', // main special 不同的装修页
    bannerBg: 0,
  },
  getters: {
    curSelectControl(state, val) {
      // -> getters['account/isAdmin']
      return (
        state.workControlList.find(
          t => t._frontId === state.curSelectControlId
        ) ||
        state.workHeadList.find(t => t._frontId === state.curSelectControlId)
      );
    },
    isDiffBackup(state) {
      return (
        !_.isEqual(state.workControlListBackup, state.workControlList) ||
        !_.isEqual(state.workHeadListBackUp, state.workHeadList)
      );
    },
    workControlList(state) {
      return state.workControlList;
    },
  },

  mutations: {
    // 存储选中的颜色  暂用
    SAVE_BACKGROUND_COLOR: (state, index) => {
      state.bannerBg = index;
    },
    // 删除
    DEL_WORK_CONTROL_ITEM: (state, _frontId) => {
      state.workControlList = state.workControlList.filter(
        t => t._frontId !== _frontId
      );
      state.workHeadList = state.workHeadList.filter(
        t => t._frontId !== _frontId
      );

      state.curSelectControlId = null;
    },
    // 初始化
    INIT_WORK_CONTROL_LIST: (
      state,
      {
        list,
        listHead = [],
        listdesc = null,
        version,
        shopFormData,
        background,
        animationFlag,
        liveFlag,
        curSelectControlId = null,
        channelTypeList = [],
      }
    ) => {
      state.listdesc = _.cloneDeep(listdesc);
      state.workControlListBackup = _.cloneDeep(list);
      state.workHeadListBackUp = _.cloneDeep(listHead);
      state.workControlList = _.cloneDeep(list);
      state.workHeadList = _.cloneDeep(listHead);
      state.version = version;
      state.curSelectControlId = curSelectControlId;
      state.background = background;
      state.channelTypeList = channelTypeList;
      state.animationFlag = animationFlag;
      state.liveFlag = liveFlag;
      state.shopFormData = shopFormData;
      //  commit('SELECT_WORK_CONTROL_ITEM_ATTR', {
      //    _frontId: state.workHeadList[0]._frontId,
      //    type: 1,
      //  });
      // }
    },
    // 赋值
    SET_WORK_HEADER_CONTROL_LIST: (state, { list }) => {
      state.workHeadList = list;
    },
    // 赋值
    SET_WORK_CONTROL_LIST: (state, { list }) => {
      state.workControlList = list;
    },
    // 重新备份
    BACK_WORK_CONTROL_LIST: state => {
      state.workControlListBackup = _.cloneDeep(state.workControlList);
      state.workHeadListBackUp = _.cloneDeep(state.workHeadList);
    },
    // 选中组件，修改属性
    SELECT_WORK_CONTROL_ITEM_ATTR: (state, { _frontId }) => {
      if (state.isPreviewState) return;
      state.curSelectControlId = _frontId;
    },
    // 保存修改属性
    SAVE_WORK_CONTROL_ITEM_ATTR: (state, { _frontId, attrs }) => {
      const item =
        state.workControlList.find(t => t._frontId === _frontId) ||
        state.workHeadList.find(t => t._frontId === _frontId);
      item.attrs = _.cloneDeep(attrs);
    },
    START_DRAG_CONTROL: state => {
      state.isDragControl = true;
    },
    END_DRAG_CONTROL: state => {
      state.isDragControl = false;
    },
    SET_ANIMATION: (state, v) => {
      state.animationFlag = v;
    },
    SET_CHANNEL: (state, v) => {
      state.channelTypeList = v;
    },
    SET_LIVE: (state, v) => {
      state.liveFlag = v;
    },
    SET_BG: (state, v) => {
      state.background = v;
    },
    SET_STORE_TYPE: (state, v) => {
      state.storeType = v;
    },
    SET_PREVIEW_STATE: (state, v) => {
      state.isPreviewState = v;
    },
  },

  actions: {
    // 初始化
    async initWorkControlList(
      { commit, state },
      { shopFormData, curSelectControlId }
    ) {
      const DEF_DATA = {
        version: '2',
        list: [],
        listHead: [],
        background: '#f8f8f8',
        animationFlag: false,
        liveFlag: false,
        channelTypeList: [],
      };
      let curData;
      if (shopFormData.id) {
        try {
          curData = JSON.parse(shopFormData.content);
        } catch (e) {
          await MessageBox({
            message: '装修数据有误',
            showCancelButton: false,
            confirmButtonText: '确定',
          });
          location.reload();
          return;
        }
        // 保证历史数据有key, 不然会不响应, 顺带了默认值..
        curData.list = curData.list.map(t => {
          const DEF_CONTROL = controlSchema[0].data.find(
            k => k.type === t.type
          );
          return _.merge(_.cloneDeep(DEF_CONTROL) || {}, t);
        });

        // todo 处理历史数据
        curData.version = '2'; // 升级v2版本
        curData = {
          ..._.cloneDeep(DEF_DATA),
          ...curData,
          liveFlag: curData.liveFlag !== false, // 历史数据判断
        };
      } else {
        curData = _.cloneDeep(DEF_DATA);
      }
      initFooterNavData(curData, state.storeType);
      // 初始化头部

      curData.listHead = curData.listHead || [];
      if (curData.listHead[0]?.type !== 'headNav') {
        curData.listHead.unshift({
          type: 'headNav',
          label: '头部标题',
          _frontId: utils.genId(),
          attrs: {
            titleALign: 0,
            titleStyle: 0,
            titleContent: shopFormData.storeName || '',
            imgs: {},
          },
        });
      }
      // todo 处理历史数据
      // 保证历史数据有key, 不然会不响应, 顺带了默认值..
      curData.listHead = curData.listHead.map(t => {
        const DEF_CONTROL = controlSchema[0].data.find(k => k.type === t.type);
        return _.merge(_.cloneDeep(DEF_CONTROL) || {}, t);
      });

      // 提交数据
      commit('INIT_WORK_CONTROL_LIST', {
        ...curData,
        background: shopFormData.background,
        shopFormData,
        curSelectControlId,
      });

      // 自动选中第一个 需要
      if (!curSelectControlId && curData.list.length) {
        commit('SELECT_WORK_CONTROL_ITEM_ATTR', {
          _frontId: curData.listHead?.[0]?._frontId,
          type: 1,
        });
      }
    },
    // 保存
    async save({ dispatch, commit, state }) {
      console.log('decoration data: ', state);
      const { data } = await _submit('save', state);
      return dispatch('initWorkControlList', {
        shopFormData: data.data,
        curSelectControlId: state.curSelectControlId,
      });
    },
    async validAll({ commit, state }, { appThis }) {
      if (!state.workControlList.length) {
        Message.info('请至少选择一个组件');
        return;
      }
      // 验证信息
      let errItem = null;
      for (let index = 0; index < state.workControlList.length; index++) {
        const item = state.workControlList[index];
        const rules = item.attrs.rules || attrRules(item.type, appThis);
        const validator = new Schema(rules);
        errItem = await new Promise(resolve => {
          validator.validate(item.attrs, (errors, fields) => {
            if (errors) {
              resolve({ errors, index, item });
            } else {
              resolve(null);
            }
          });
        });
        if (errItem) {
          break;
        }
      }
      // 出错处理
      if (errItem) {
        const { errors, item } = errItem;
        Message.info(errors[0].message);
        commit('SELECT_WORK_CONTROL_ITEM_ATTR', {
          _frontId: item._frontId,
        });
        return false;
      } else {
        return true;
      }
    },
    // 发布
    async publish({ commit, state }) {
      await _submit('publish', state);
      // 备份重置
      commit('BACK_WORK_CONTROL_LIST');
      return true;
    },
  },
};

/**
 * 门店自提底部导航配置项
 * 由于门店自提底部无法配置，故小程序端只取默认配置项
 */
const getStoreFooterNavCfg = () => ({
  type: 'footerNav',
  label: '底部导航',
  attrs: {
    tableData: [
      {
        linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
          systemLink: {
            type: 'function',
            link: 'home',
            name: '首页',
          },
        }),
        linkUrl: 'home',
        name: '首页',
        index: 0,
        defaultIcon: 'home-3',
        selectIcon: 'home-3-active',
      },
      {
        linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
          systemLink: {
            type: 'function',
            link: 'cart',
            name: '购物车',
          },
        }),
        linkUrl: 'cart',
        name: '购物车',
        defaultIcon: 'cart-3',
        selectIcon: 'cart-3-active',
      },
      {
        linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
          systemLink: {
            type: 'function',
            link: 'order',
            name: '订单',
          },
        }),
        linkUrl: 'order',
        name: '订单',
        defaultIcon: 'order-3',
        selectIcon: 'order-3-active',
      },
    ],
    styleType: 1,
    iconStyleType: 1,
    hideFooterNav: false,

    defaultFontColorType: 1,
    selectFontColorType: 1,
    defaultFontColor: '#f1f1f1',
    selectFontColor: '#f1f1f1',
    textAndImgFomart: 1,
  },
  dragDisable: true,
  absoluteDisplay: true,
  cantDelete: true,
  fixed: true,
});

const getDefaultFooterNavData = storeType => {
  // 门店自提页配置
  if (appStore.state.sellerBookingType === 1 && storeType !== 'special') {
    return getStoreFooterNavCfg();
  }
  return {
    type: 'footerNav',
    label: '底部导航',
    attrs: {
      tableData: [
        {
          linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
            systemLink: { type: 'function', link: 'home', name: '首页' },
          }),
          name: '首页',
          index: 0,
          defaultIcon: 'home-0',
          selectIcon: 'home-0-active',
        },
        {
          linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
            systemLink: { type: 'function', link: 'category', name: '分类页' },
          }),
          name: '分类',
          defaultIcon: 'category-0',
          selectIcon: 'category-0-active',
        },
        {
          linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
            systemLink: {
              type: 'function',
              link: 'cart',
              name: '购物车',
            },
          }),
          name: '购物车',
          defaultIcon: 'cart-0',
          selectIcon: 'cart-0-active',
        },
        {
          linkItem: _.merge({}, CONST.DEF_LINK_ITEM, {
            systemLink: { type: 'function', link: 'mine', name: '我的' },
          }),
          name: '我的',
          defaultIcon: 'mine-0',
          selectIcon: 'mine-0-active',
        },
      ],
      styleType: 1,
      iconStyleType: 1,
      hideFooterNav: storeType === 'special',

      defaultFontColorType: 1,
      selectFontColorType: 1,
      defaultFontColor: '#f1f1f1',
      selectFontColor: '#f1f1f1',
      textAndImgFomart: 1,
    },
    dragDisable: true,
    absoluteDisplay: true,
    cantDelete: true,
    fixed: true,
  };
};

export default decoration;
